// src/private/colorPalette.js
// Shared color-grid source: every right-click/toolbar color picker in the
// canvas (scenario connectors, sticky notes) expands its base palette into
// a grid of the base color plus lighter tonal shades, instead of offering
// only the flat saturated swatches.

// Connector/path-highlight palette — the app's own brand/phase tokens
// (theme.js's cyanText/coralText, Chatbot.jsx's PHASE_META colors).
export const BRAND_PALETTE = ["#147696", "#B24A35", "#8b5cf6", "#ec4899", "#0ea5e9", "#f59e0b", "#10b981"];

// Sticky-note background palette — soft pastels, distinct from the brand
// palette above (notes are content backgrounds, not path highlights).
export const NOTE_PALETTE = ["#FFE066", "#C3F0CA", "#BFE3FF", "#FFD0E0", "#E3D4FF", "#FFD8B0", "#E6E8EB"];

function hexToRgb(hex) {
  const h = hex.replace("#", "");
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
}
function rgbToHex([r, g, b]) {
  return "#" + [r, g, b].map((v) => Math.round(v).toString(16).padStart(2, "0")).join("");
}
// Lightens a hex color toward white by `amt` (0-1).
function lighten(hex, amt) {
  const [r, g, b] = hexToRgb(hex);
  return rgbToHex([r + (255 - r) * amt, g + (255 - g) * amt, b + (255 - b) * amt]);
}

const TINT_STEPS = [0.25, 0.45, 0.65, 0.85]; // 4 lighter shades per base color

// Expands a flat base-color list into one row per color: [base, tint1..tint4].
export function withTints(baseColors) {
  return baseColors.map((base) => [base, ...TINT_STEPS.map((t) => lighten(base, t))]);
}

// Auto-assigned per-scenario connector color (ScenarioTimeline.jsx branch
// paths/pills) — round-robin through the 7 BRAND_PALETTE hues first (so any
// two live scenarios are always distinguishable), then once that's
// exhausted, cycle back through the same 7 hues at their next-lighter tint
// step (still "adjacent" to the base color, not an arbitrary new hue)
// before repeating. 7 hues x 5 tint steps = 35 distinct colors before a
// repeat.
const BRANCH_COLOR_SEQUENCE = (() => {
  const rows = withTints(BRAND_PALETTE); // 7 rows x [base, tint1..tint4]
  const flat = [];
  for (let col = 0; col < rows[0].length; col++) {
    rows.forEach((row) => flat.push(row[col]));
  }
  return flat;
})();

export function scenarioBranchColor(index) {
  return BRANCH_COLOR_SEQUENCE[((index % BRANCH_COLOR_SEQUENCE.length) + BRANCH_COLOR_SEQUENCE.length) % BRANCH_COLOR_SEQUENCE.length];
}
